export class PlayerSearchParameters
{
    OrganizationId: string;
    FirstName: string;
    LastName: string;
    PositionIds: number[];
    ShotIds: number[];

}